import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Category from '../components/Category';
import ProjectsVideo from '../components/ProjectsVideo';
import BackArrow from '../components/BackArrow';

import '../css/projects.css';

import auditionTapes1 from '../img/audition-tapes/jamie-sparker-audition-tapes.png';
import auditionTapes2 from '../img/audition-tapes/jamie-sparker-audition-tapes2.png';
import auditionTapes3 from '../img/audition-tapes/jamie-sparker-audition-tapes3.png';

function AudtionTapes() {
  const [popupOn, setPopupOn] = useState(false);
  const [url, setUrl] = useState('');
  const [videoTitle, setVideoTitle] = useState('');
  const [description, setDescription] = useState('');

  return (
    <Container id='projects'>
      <BackArrow lastPage='/projects' />
      <Row className='projects-row'>
        <Category
          photo={auditionTapes1}
          title={`#1`}
          overlay={'0.3'}
          routable={false}
          popup={true}
          hover={true}
          setPopupOn={setPopupOn}
          video={true}
          url='https://www.youtube.com/embed/VWv0WXvCZmo'
          videoTitle='DC´s Midnighter'
          description={`The script was written exclusively for audition purposes and does not represent the movie content.`}
          setUrl={setUrl}
          setVideoTitle={setVideoTitle}
          setDescription={setDescription}
        />
        <Category
          photo={auditionTapes2}
          title={`#2`}
          overlay={'0.3'}
          routable={false}
          popup={true}
          hover={true}
          setPopupOn={setPopupOn}
          video={true}
          url='https://www.youtube.com/embed/v7xjo-B19Mw'
          videoTitle='DC´s Midnighter'
          description={`The script was written exclusively for audition purposes and does not represent the movie content.`}
          setUrl={setUrl}
          setVideoTitle={setVideoTitle}
          setDescription={setDescription}
        />
        <Category
          photo={auditionTapes3}
          title={`#3`}
          overlay={'0'}
          routable={false}
          popup={true}
          hover={true}
          setPopupOn={setPopupOn}
          video={true}
          url='https://www.youtube.com/embed/uZWxipnukbs'
          videoTitle='WandaVision (Wiccan)'
          description={`The script was written exclusively for audition purposes and does not represent the movie content.`}
          setUrl={setUrl}
          setVideoTitle={setVideoTitle}
          setDescription={setDescription}
        />
        <ProjectsVideo
          video={true}
          videoTitle={videoTitle}
          description={description}
          url={url}
          popupOn={popupOn}
          setPopupOn={setPopupOn}
        />
      </Row>
    </Container>
  );
}

export default AudtionTapes;
